import { render, staticRenderFns } from "./HistoryDaysOff.vue?vue&type=template&id=dc1058da&"
import script from "./HistoryDaysOff.vue?vue&type=script&lang=js&"
export * from "./HistoryDaysOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports